module.exports = function getResource(label, vars = []) {
    let resources = {
        colorIQMatches: 'Your Color iQ Matches',
        save: 'Save'
    };

    return resources[label];
};
